import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class UsuarioProvider {
    boasVindas(): Promise<PhicubeResponse> {
        return new GatewayService().requestPut('/api/user/boasVindas', {})
    }

    informacoesUsuario(): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/user/me')
    }
}